import Vue from 'vue'

import api from '../api'

export default {
  state: {
    releases: {
      1: {}
    }
  },
  getters: {
    getReleasesForProject(state) {
      return project => state.releases[project].releases
    }
  },
  mutations: {
    setReleaseData(state, { project, releaseData }) {
      Vue.set(state.releases, project, releaseData)
    }
  },
  actions: {
    async fetchReleases({ commit }, { project }) {
      const response = await api.get(`releases/${project}`)
      const releaseData = response.data

      commit('setReleaseData', { project, releaseData })
    },
    async storeRelease({ getters, commit }, { project, commitId, release }) {
      const response = await api.post(`releases/${project}/${commitId}`, release)
      const data = response.data
      const commits = getters.getCommitsForProject(project)
      release = data.release

      commit('setCommitRelease', { commits, commit: commitId, release })
      return release
    },
    async fetchLatestRelease(context, { releaseTrack }) {
      const response = await api.get(`bridges/releases/latest/${releaseTrack}`)
      const release = response.data

      return release
    },
    async pinToLatestRelease(context, { serialNumber }) {
      const response = await api.patch(`bridges/${serialNumber}/update-latest`)

      return response
    }
  }
}